<script>
import paystack from "vue-paystack";
import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from "firebase/functions";
export default {
  name: "StrappPaystackButton",
  components: {
    paystack,
    Loader: () => import("@/components/Loader.vue"),
  },
  props: ["item"],

  data() {
    return {
      PUBLIC_KEY: "pk_test_a4dac53fcfd9ab64946bafbb665827c0b146a079",
      paymentFailDialog: false,
      loading: false,
    };
  },
  // computed: {
  //   loading() {
  //     return this.$store.getters.loading;
  //   },
  // },
  methods: {
    async updateBooking() {
      this.paymentFailDialog = false;
      console.log("here", this.$route.params.id);

      this.loading = true;

      // const db = getFirestore();

      // const newPayDoc = await addDoc(salesPaymentsCollection, {
      //   amount: 100, // Example field: amount
      //   date: new Date(), // Example field: date
      //   // Add more fields as needed
      // });

      // console.log("Document written with ID: ", newPayDoc.id);

      const functions = getFunctions();
      // connectFunctionsEmulator(functions, "localhost", 5001);

      const verifyPaystackPayment = httpsCallable(
        functions,
        "verifyPaystackPayment"
      );

      verifyPaystackPayment({
        ref: this.$route.params.id,
        userId: this.$store.getters.user.id,
        userEmail: this.$store.getters.user.email,
        sellerName: this.item.created_by,
        itemName: this.item.itemName,
        location: this.item.location,
        sellerId: this.item.sellerId,
      }).then((result) => {
        // Read result of the Cloud Function.
        /** @type {any} */
        const data = result.data;
        this.loading = true;
        console.log("data", data);

        if (data === "success") {
          this.$emit("paySuccess");
          this.loading = false;
          console.log("success we here");
        } else {
          console.log("fail we here");
          this.loading = false;
          this.paymentFailDialog = true;
        }
      });
    },
    close: () => {
      console.log("You closed checkout page");
    },
  },
};
</script>

<template>
  <div>
    <v-overlay v-if="loading == true">
      <Loader />
    </v-overlay>
    <paystack
      :amount="this.item.price * 100"
      :email="this.$store.getters.user.email"
      :reference="this.$route.params.id"
      :paystackkey="PUBLIC_KEY"
      :callback="updateBooking"
      :channels="[
        'card',
        'bank',
        'ussd',
        'qr',
        'eft',
        'mobile_money',
        'bank_transfer',
      ]"
      :close="close"
      currency="ZAR"
      :embed="false"
    >
      <v-btn
        elevation="6"
        large
        block
        color="accent"
        class="ml-n3 appbutton ma-1 text-body-1 rounded-lg white--text font-weight-medium"
        z-index="12"
      >
        <base-img
          :src="require('@/assets/payment/paystack.svg')"
          contain
          max-height="25"
          max-width="25"
          class="mr-3 mr-1"
        />
        Pay R
        <span>{{ item.price }}</span>
      </v-btn>
    </paystack>

    <v-dialog
      v-model="paymentFailDialog"
      max-width="450px"
      persistent
      transition="dialog-bottom-transition"
    >
      <template>
        <v-card style="border-radius: 12px !important" class="text-center">
          <v-card-title class="text-center black--text">
            <p class="my-3 ml-auto mr-auto">Payment failure!</p>
          </v-card-title>
          <v-divider></v-divider>
          <div class="grid">
            <v-img
              size="small"
              width="300px"
              height="300px"
              :src="require('@/assets/svgs/question-2.svg')"
            ></v-img>
          </div>
          <v-card-text class="my-2">
            Your payment was unsuccesful or may still be in a pending state. If
            your payment has gone through, please click the button below to try
            get the response again.
          </v-card-text>

          <v-card-actions class="mt-n9">
            <v-col>
              <v-row class="my-3">
                <v-btn
                  block
                  class="btn white--text"
                  style="border-radius: 8px !important"
                  color="accent"
                  @click="updateBooking()"
                >
                  try again
                </v-btn>
              </v-row>
              <v-row class="my-3">
                <v-btn
                  block
                  class="btn white--text"
                  style="border-radius: 8px !important"
                  color="accent"
                  @click="paymentFailDialog = false"
                >
                  close
                </v-btn>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
.appbutton {
  font-weight: 700;
  transition: 0.5s;
  box-shadow: #b22af0 0px 5px 15px;
  background: rgb(247, 150, 192);
  background: radial-gradient(circle, #6db2e3 0%, #b22af0 100%);
  transition: all 0.3s ease 0s;
}
</style>
